// AUTO-GENERATED: 2025-10-28T19:10:34.717567Z
// 🍔 Western recipes

export const westernRecipes = [
{
    name: "Beef Burger",
    cuisine: "Western",
    ingredients: ["ground beef", "lettuce", "tomato", "onion", "pickles", "burger buns"],
    sauces: ["ketchup", "mayonnaise", "mustard"],
    instructions: "Season beef patties with salt and pepper. Grill or pan-fry for 3-4 minutes per side until cooked through. Toast buns lightly. Layer lettuce, tomato, onion, pickles on bottom bun, add cooked patty, spread sauces on top bun, and assemble.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Grilled Chicken Salad",
    cuisine: "Western",
    ingredients: ["chicken breast", "lettuce", "cherry tomatoes", "cucumber", "carrots", "croutons"],
    sauces: ["olive oil", "balsamic vinegar", "ranch dressing"],
    instructions: "Season chicken breasts with salt, pepper, and herbs. Grill for 6-7 minutes per side until cooked through. Let rest, then slice. Chop lettuce, tomatoes, cucumber, and carrots. Toss vegetables with dressing, top with sliced chicken and croutons.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Fish and Chips",
    cuisine: "Western",
    ingredients: ["cod fillets", "potatoes", "flour", "eggs", "breadcrumbs"],
    sauces: ["tartar sauce", "malt vinegar", "lemon juice"],
    instructions: "Cut potatoes into thick fries and deep fry until golden. Coat fish in flour, dip in beaten eggs, then breadcrumbs. Deep fry fish for 4-5 minutes until golden and crispy. Drain on paper towels. Serve hot with tartar sauce, malt vinegar, and lemon wedges.",
    time: "35 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Roast Chicken",
    cuisine: "Western",
    ingredients: ["whole chicken", "potatoes", "carrots", "onions", "garlic", "herbs"],
    sauces: ["butter", "gravy", "olive oil"],
    instructions: "Preheat oven to 425°F. Rub chicken with butter, salt, pepper, and herbs. Place in roasting pan with potatoes, carrots, and onions. Roast for 60-75 minutes until internal temperature reaches 165°F. Let rest 10 minutes. Make gravy from pan drippings. Carve and serve.",
    time: "90 min",
    difficulty: "Hard",
    points: 150,
    servings: 2
  },
{
    name: "Mac and Cheese",
    cuisine: "Western",
    ingredients: ["macaroni pasta", "cheddar cheese", "milk", "butter", "flour"],
    sauces: ["cheese sauce", "butter"],
    instructions: "Cook macaroni according to package directions. Make cheese sauce by melting butter, adding flour, then milk to create a roux. Add shredded cheddar and stir until melted and smooth. Mix cooked pasta with cheese sauce. Optional: top with breadcrumbs and bake at 350°F for 20 minutes.",
    time: "30 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "BBQ Ribs",
    cuisine: "Western",
    ingredients: ["pork ribs", "onion", "garlic"],
    sauces: ["bbq sauce", "apple cider vinegar", "brown sugar", "dry rub"],
    instructions: "Remove membrane from ribs. Apply dry rub generously. Wrap in foil and bake at 275°F for 2.5 hours. Unwrap, brush with BBQ sauce, and grill or broil for 10-15 minutes, basting frequently. Let rest 5 minutes, then cut between bones and serve.",
    time: "180 min",
    difficulty: "Hard",
    points: 150,
    servings: 2
  },
{
    name: "Pancakes",
    cuisine: "Western",
    ingredients: ["flour", "eggs", "milk", "sugar", "baking powder", "butter"],
    sauces: ["maple syrup", "honey", "butter"],
    instructions: "Mix flour, sugar, baking powder, and salt. In another bowl, whisk eggs, milk, and melted butter. Combine wet and dry ingredients until just mixed. Heat griddle to 350°F. Pour 1/4 cup batter per pancake. Cook until bubbles form, flip, cook 1-2 minutes more. Serve hot with syrup.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Shepherd's Pie",
    cuisine: "Western",
    ingredients: ["ground lamb", "potatoes", "carrots", "peas", "onion", "garlic"],
    sauces: ["worcestershire sauce", "tomato paste", "beef broth", "butter"],
    instructions: "Boil potatoes until tender, mash with butter and milk. Brown ground lamb with onions and garlic. Add carrots, peas, tomato paste, worcestershire sauce, and broth. Simmer 15 minutes. Transfer to baking dish, top with mashed potatoes. Bake at 400°F for 25 minutes until golden.",
    time: "60 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Caesar Salad",
    cuisine: "Western",
    ingredients: ["romaine lettuce", "parmesan cheese", "croutons", "chicken breast"],
    sauces: ["caesar dressing", "lemon juice", "olive oil"],
    instructions: "Grill or pan-sear chicken breast, let rest and slice. Chop romaine lettuce into bite-sized pieces. Toss lettuce with Caesar dressing until well coated. Add croutons and shaved parmesan. Top with sliced chicken. Serve immediately while croutons are still crispy.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Garlic Mashed Potatoes",
    cuisine: "Western",
    ingredients: ["potatoes", "garlic", "milk", "butter"],
    sauces: ["butter", "cream", "sour cream"],
    instructions: "Peel and cut potatoes into chunks. Boil in salted water with garlic cloves until tender, 15-20 minutes. Drain well. Mash with butter and warm milk until smooth and creamy. Season with salt and pepper. Optionally fold in sour cream for extra richness. Serve hot.",
    time: "30 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  }
];
